import {Component} from "@angular/core";

@Component({
    selector: "fui-fab-section",
    styleUrls: ["./fab-section.component.scss"],
    templateUrl: "./fab-section.component.html"
})
export class FUIFABSectionComponent {
}
